import { render } from "./DependencyItem.vue?vue&type=template&id=cdb7d5ea"
import script from "./DependencyItem.vue?vue&type=script&lang=js"
export * from "./DependencyItem.vue?vue&type=script&lang=js"

import "./DependencyItem.vue?vue&type=style&index=0&id=cdb7d5ea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__